module.exports = __webpack_public_path__ + "logo_2.png?c00ae0b6de88520808c8f905fb9054c8";


//////////////////
// WEBPACK FOOTER
// ./src/img/login/logo_2.png
// module id = 710
// module chunks = 20